import { FC } from 'react'

import { StyledDialogActions } from './dialog-actions.styles'
import { DialogActionsProps } from './dialog-actions.types'

export const DialogActions: FC<DialogActionsProps> = ({ children, ...props }) => (
  <StyledDialogActions {...props}>{children}</StyledDialogActions>
)
